import { Type } from "@sinclair/typebox";
import { ActiveActions } from "./integrations/appsActions/ActiveActions";
export const AppsNames = Type.Union([
  Type.Literal("salesforce"),
  Type.Literal("zoom"),
  Type.Literal("teams"),
  Type.Literal("google"),
  Type.Literal("docusign"),
  Type.Literal("outlook"),
  Type.Literal("msdynamics"),
  Type.Literal("hubspot"),
  Type.Literal("microsoft"),
  Type.Literal("hubspotIntegration"),
  Type.Literal("pipedrive"),
  Type.Literal("slack"),
  Type.Literal("tuvisTeamsApp"),
]);
export type AppsWithMoreInfoType = "zoom" | "teams" | "google" | "docusign" | "outlook";

/**
 * Display names for the App Directory apps, shared by the widget UI and server-side analytics so the
 * two can't drift. `upperFirst(appName)` won't do — it yields "Docusign"/"Google".
 */
export const APP_DIRECTORY_LABELS: Record<AppsWithMoreInfoType, string> = {
  zoom: "Zoom",
  teams: "Microsoft Teams",
  google: "Google Meet",
  docusign: "DocuSign",
  outlook: "Microsoft Outlook",
};
export type AppsWithLogin = AppsWithMoreInfoType | "hubspotIntegration" | "pipedrive" | "slack";

export type AppsNamesType = keyof ActiveActions;
